/** Transport BroadcastChannel (index.html:2179-2184) : zéro serveur, pour tests/e2e/dev hors-ligne. */
import { ROOM_PREFIX } from '@ordre-cache/shared';
import type { NetHandler, Transport } from './transport';

interface BcEnvelope {
  __f: string;
  m: unknown;
}

export function makeBcTransport(code: string, myId: string, onEvent: NetHandler): Transport {
  const bc = new BroadcastChannel(ROOM_PREFIX + code);
  bc.onmessage = (e: MessageEvent<BcEnvelope>) => {
    if (e.data && e.data.__f !== myId) onEvent('msg', e.data.m);
  };
  setTimeout(() => onEvent('open'), 0);
  return {
    send: (m: unknown) => {
      try {
        bc.postMessage({ __f: myId, m });
      } catch {
        /* canal fermé */
      }
    },
    close: () => {
      try {
        bc.close();
      } catch {
        /* déjà fermé */
      }
    },
  };
}
